import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Popup } from 'semantic-ui-react';
import i18next from 'i18next';

import './DayCellHeader.scss';

class DayCellHeader extends Component {

    render() {
        const { day, numberOfSegments, addSegmentToDay } = this.props;

        return (
            <Table.HeaderCell key={day} colSpan={numberOfSegments}>
                {i18next.t('day' + (day))}
                <Popup
                    trigger={
                        <Button floated='right' basic size='tiny' compact primary icon='add' onClick={() => addSegmentToDay(day)} />
                    }
                    content={i18next.t('schedule.addSegment')}
                    inverted
                    position='bottom center'
                />
            </Table.HeaderCell>
        );
    }
}

DayCellHeader.propTypes = {
    day: PropTypes.number,
    numberOfSegments: PropTypes.number,
    addSegmentToDay: PropTypes.func,
    
};

export default DayCellHeader;